import React, {useState, useEffect} from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import InputMasked from "react-input-mask";
import moment from "moment";
import Tour from "reactour";

import api from "../../service/api";

import Select from "../../components/Select";
import DashboardHeader from "../../components/DashboardHeader";
import DashboardBalanceBox from "../../components/DashboardBalanceBox";
import DashboardLastTransfers from "../../components/DashboardLastTransfers";
import Graphic from "../../components/Graphic";
import Table from "../../components/Table";
import Modal from "../../components/ModalActions";
import ModalDetails from "../../components/ModalDetails";
import Input from "../../components/Input";
import { TitleTour, ContentText } from "../../components/ReactourComponents/styles";

import "react-dates/initialize";

import { 
  Main,
  CircleStatus, 
  DetailsButton, 
  BalanceContainer,
  DashboardBalanceBoxContainer,
  BalanceCurrecy, 
  BalanceValue, 
  TransferContainer,
  TransferBalance,
  FormAndTransferContainerFlex,
  FormInput,
  BankAccountAndSelectAnotherContainer,
  TableTitle,
  Title,
  LinkToChatMobile,
  LinkToChatContainer, 
  LinkToChatBallon,
  BallonTriangle,
  LinkToChatTextBlack, 
  LinkToChatTextRed, 
  SideContainer, 
  THead, 
  Td, 
  Th, 
  ThFilterable, 
  Button,
  BankAccount,
  BankAccountContainer,
  BankAccountContainerBody,
  BankAccountContainerHeader,
  BankAccountContainerHeaderTitle,
  DataContainer,
  Info,
  RadioButtonContainer,
  RadioButtonContent,
  SelectAnother,
  AccountTitle,
  SelectBranchContainer,
  SelectBranchText,
  NavigationContainer,
  TextContainer,
  InfoContainer,
  CardDetailsFutureValue
} from "./styles";

//Utils Functions
import { translatePaymentType } from "../../utils/translate/paymentType";
import { translateStatus } from "../../utils/translate/status";

//Actions Functions
import { changeUser } from "../../redux/actions/login";
import { ownerBranchs } from "../../redux/actions/branchs";

//Help Functions
import { openModal } from "../../helpers/modalFunctions";

//Help Variables
import { serverPath } from "../../helpers/helpersVariables";

//Assets
import bankWhite from "../../assets/icons/bank-white.svg";
import chatImg from "../../assets/img/faq.svg";
import upArrow from "../../assets/icons/chevron-up.svg";
import downArrow from "../../assets/icons/chevron-down.svg";
import colors from "../../assets/css/colors";
import Animation from "../../components/Animation/animation";

//Interfaces
import { PaymentOptionsDataInterface } from "../configuration/paymentOptions/interfaces";
import ModalTransfers from "../../components/ModalTransfers";
import { toastCreate } from "../../utils/notifications/toast";
import { ToastContainer } from "react-toastify";

const months = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"]

const Dashboard = () => {

  const [searchType, setSearchType] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);

  const [pageTransactions, setPageTransactions] = useState(1);
  const [maximumPageTransactions, setMaximumPageTransactions] = useState(1);

  const [transfersFuture, setTransfersFuture] = useState<Array<any>>([]);
  const [pageFuture, setPageFuture] = useState(1);
  const [maximumPageFuture, setMaximumPageFuture] = useState(1);

  const [totalAmountPerPage ,setTotalAmountPerPage] = useState(0)
  const [avaliableBalance, setAvaliableBalance] = useState(0);
  const [futureBalance, setFutureBalance] = useState(0);

  const [transactionsData, setTransactionsData] = useState<Array<any>>([]);
  const [transactionSelected, setTransactionSelected] = useState<object>({});
  const [last4Transaction, setLast4Transactions] = useState<Array<any>>([]);

  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);

  const [paymentOptionsData, setPaymentOptionsData] = useState<PaymentOptionsDataInterface>({
    account_number: "",
    bank_code: "",
    bank_name: "",
    holder_name: "",
    id: "",
    is_active: false,
    routing_check_digit: null,
    routing_number: "",
    taxpayer_id: "",
    type: ""
  });

  const [selectedTransferData, setSelectedTransferData] = useState<any>({
    amount: "",
    type: "",
    bank_account: {
      holder_name: "",
      taxpayer_id: "",
      bank_name: "",
      account_number: "",
      routing_number: "",
    },
    transfer_date: ""
  });

  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [filterGraficButton, setFilterGraficButton] = useState(2);
  const [isLoading, setIsLoading] = useState(false);


  const [typeGraphic, setTypeGraphic] = useState("line")

  const [tableNavigation, setTableNavigation] = useState(0);

  const [errorOnSubmit, setErrorOnSubmit] = useState(false);

  const [transferData, setTransferData] = useState<Array<any>>([]);
  const [transferPage, setTransferPage] = useState(1);
  const [transferMaxPage, setTransferMaxPage] = useState(1);

  const [isTourOpen, setIsTourOpen] = useState(false);

  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);

  const login = useSelector((state: {login: any}) => state.login);
  const owner = useSelector((state: {branchs: any}) => state.branchs);

  const [branchs, setBranchs] = useState<Array<any>>([
    {
      ownersId: login.user.ownersId,
    }
  ]);

  const [selectedBranch, setSelectedBranch] = useState(branchs[0]);

  const dispatch = useDispatch();

  const history = useHistory();

  useEffect(() => {
    const openTourIfUserDontSeeBefore = () => {
      const pastVersions: any = JSON.parse(localStorage.getItem("versions") || "{}");
  
      if(pastVersions[login.user.id] === undefined){
        setIsTourOpen(true);
        
        const addNewVersion = {
          ...pastVersions,
          [login.user.id]: [
            "1.0.1"
          ]
        }
  
        localStorage.setItem("versions", JSON.stringify(addNewVersion));
      } else {
        if(!pastVersions[login.user.id].includes("1.0.1")){
          setIsTourOpen(true);
  
          const addNewVersion = {
            ...pastVersions,
            [login.user.id]: [
              ...pastVersions[login.user.id],
              "1.0.1"
            ]
          }
  
          localStorage.setItem("versions", JSON.stringify(addNewVersion));
        }
      }
    }

    if(login.user.groups.cm1r1 === true){
      openTourIfUserDontSeeBefore();
    }
  }, []);

  useEffect(() => {
    const ifThisUserIsSuperGetTheBranchs = async () => {
      const { data } = await api.get("/adm/owner100pay/list", {
        params: {
          id: login.user.owners.id,
        }
      });
      
      dispatch(ownerBranchs([...data.Branch]));
      dispatch(changeUser({
        ...login.user,
        branchs: data.Branch[0],
        branchsId: data.Branch[0].id
      }));
      setSelectedBranch(data.Branch[0].id);
    }

    const setActiveBranch = async () => {
      const { data } = await api.get("/adm/owner100pay/list", {
        params: {
          id: login.user.owners.id,
          powerUser: login.user.powerUser
        }
      });
      
      dispatch(ownerBranchs([...data.Branch]));
      dispatch(changeUser({
        ...login.user,
        branchs: data.Branch[0],
        branchsId: data.Branch[0].id
      }));
      setSelectedBranch(data.Branch[0].id);
    }
    
  if(login.user.powerUser === true) {
    setActiveBranch()
  } else if(owner.branchs.length === 0 && login.user.powerUser === false){
      ifThisUserIsSuperGetTheBranchs();
    }
  }, []);

  useEffect(() => {
    const getAvaliableBalanceAtApi = async () => {
      const {data} = await api.get("/branch/balance", {   
        params: {
          "sellerOwnerPayId": login.user.branchs.sellerOwnerPayId,
          "apiOwnerId": "ZOOP"//login.user.branchs.apiOwner.description
        }
      });
      
      if(data.items !== undefined){
        setAvaliableBalance(parseFloat(data.items.current_balance) / 100);
        setFutureBalance(parseFloat(data.items.account_balance) / 100);
      }
    }

    const getBankAccountAtApi = async () => {
      const {data} = await api.get("/branch/bank/account", {
        params: {
          "sellerOwnerPayId": login.user.branchs.sellerOwnerPayId,
          "apiOwnerId": "ZOOP" //login.user.branchs.apiOwnerId
        }
      });
      
      if(data.items !== undefined){
        const primaryAccont = data.items.filter((account: PaymentOptionsDataInterface) => account.is_active);
        
        setPaymentOptionsData(primaryAccont[0]);
      }
    }
  
    const getLastTransactionsAtApi = async () => {
      const {data} = await api.get("/dashboard/transaction", {
        params: {
          sellerOwnerPayId: login.user.branchs.sellerOwnerPayId
        }
      });
      
      setLast4Transactions(data.Buyer);
      
    }

    if(login.user.branchsId !== null){  
      getAvaliableBalanceAtApi();
      getBankAccountAtApi();
      getLastTransactionsAtApi()
    }
  }, [login.user.branchsId])

  useEffect(() => {
    const getTransactionsAtApi = async () => {
      let data = [];
      
      if(filterGraficButton === 2){
        const response = await api.get("/transaction/list", {
          params: {
            page: pageTransactions,
            bid: login.user.branchs.sellerOwnerPayId,
            apiOwnerId: "ZOOP", //login.user.branchs.apiOwner.description,
            week: true
          }
        });
        
        data = response.data;
      setIsLoading(false);

      }
      
      if(filterGraficButton === 1){
        const response = await api.get("/transaction/list", {
          params: {
            page: pageTransactions,
            bid: login.user.branchs.sellerOwnerPayId,
            apiOwnerId: "ZOOP", //login.user.branchs.apiOwner.description,
            month: moment().month() + 1
          }
        });
        
        data = response.data;
      setIsLoading(false);

      }
      
      if(filterGraficButton === 0 && startDate !== null && endDate !== null){
        const response = await api.get("/transaction/list", {
          params: {
            page: pageTransactions,
            bid: login.user.branchs.sellerOwnerPayId,
            "apiOwnerId": login.user.powerUser === true ? "ZOOP" : login.user.branchs.apiOwner.description,
            fdate: moment(startDate).format("YYYY-MM-DD"),
            ldate: moment(endDate).format("YYYY-MM-DD")
          }
        });
        
        data = response.data;
      setIsLoading(false);

      }
  
      if(data.Transactions !== undefined){
        setTransactionsData(data.Transactions);
        setMaximumPageTransactions(data.pageCount);
      }
    }
    
    if(pageTransactions !== 0 && login.user.branchsId !== null && debouncedSearchTerm === ""){
      getTransactionsAtApi();
    }
  }, [pageTransactions, filterGraficButton, startDate, endDate, login.user.branchsId, debouncedSearchTerm]);

  useEffect(() => {
    const getFutureTransfersAtApi = async () => {
      try {
        const { data } = await api.get("/branch/transfers/future", {
          params: {
            sellerOwnerPayId: login.user.branchs.sellerOwnerPayId,
            page: pageFuture
          }
        });
        
        setTotalAmountPerPage(data.total_amount)
        setTransfersFuture(data.branchFutureTransfer);
        setMaximumPageFuture(data.pageCount);
      } catch (error) {
        
      }
    }

    getFutureTransfersAtApi();
  }, [pageFuture, login.user.branchsId])

  useEffect(() => {
    setPageTransactions(0);
    setPageTransactions(1);
  }, [filterGraficButton]);


  function verifySearch(word: string) {
    switch(word){
        case "Aprovada":
          return setDebouncedSearchTerm("succeeded");

        case "Falhada": 
          return setDebouncedSearchTerm("failed");

        case "Cancelada": 
          return setDebouncedSearchTerm("canceled");

        default:
          return setDebouncedSearchTerm(searchTerm);
    }
  }

  useEffect(() => {
    setIsLoading(true);
    const timerId = setTimeout(() => {
      setPageTransactions(1);
      verifySearch(searchTerm)
    }, 2500);

    return () => {
        clearTimeout(timerId);
    }
  }, [searchTerm]);

useEffect(() => {
  const getFilteredTransactions = async () => {
    const {data} = await api.get("/transaction/client", {
      params:{
        search: debouncedSearchTerm,
        bid: login.user.branchs.sellerOwnerPayId,
        filter: searchType,
        page: pageTransactions,
      }
    });
    
    setMaximumPageTransactions(data.pageCount)
    setPageTransactions(data.page)
    setTransactionsData(data.Transactions)
    setIsLoading(false);
  }

  if(debouncedSearchTerm !== ""){
    try{
      getFilteredTransactions()
    }catch(error){
      console.log(error)
    }
  }
}, [debouncedSearchTerm, pageTransactions]);


  const formValidationWithYup = Yup.object().shape({
    amount: Yup.string().required(),
    password_transfer: Yup.string().required()
  })

  const handleRedirect = () => {
    history.push("/admin/configuration/payment-options")
  }

  const isDetailsButtonShowed = (transaction: any) => {
    if(login.user.groups.cm1r2){ 
      return <DetailsButton onClick={() => handleDetailButtonClick(transaction)}><span style={{height: 8}}>Ver detalhes</span></DetailsButton>
    } else {
      return null
    }
  }

  const handleDetailButtonClick = async (transaction: any) => {
    try {
      const response = await api.get("/transaction/list", {
        params: {
          transactionNumber: transaction.tr_transactionNumber,
        }
      });
      const newData: object = response.data.TransactionsDetails;
      const buyer = response.data.buyer;
      const transacionCompleteData = {...transaction, ...newData, ...buyer[0]};
      
      setTransactionSelected(transacionCompleteData);
      openModal("details");
    } catch (error) {

    }
  }

  const tableContentGenerator = () => {
    if(transactionsData?.length != 0){
      return transactionsData?.map((transaction) => {
        let date = moment(transaction.tr_created_at).add(3 ,"hours").format("DD/MM/YYYY").toLocaleString(); //corringindo UTC Timezone
        let dateUpdate = moment(transaction.tr_updated_at).add(3 ,"hours").format("DD/MM/YYYY").toLocaleString();
        
        return(
          <tr key={`table_${transaction.tr_id}`} style={{ height: 67 }}>
            <Td><span>R${parseFloat(transaction.tr_amount).toLocaleString("pt-br", {minimumFractionDigits: 2, maximumFractionDigits: 2})}</span></Td>
            <Td><span>R${parseFloat(transaction.tr_fees).toLocaleString("pt-br", {minimumFractionDigits: 2, maximumFractionDigits: 2})}</span></Td>
            <Td><span>R${(parseFloat(transaction.tr_amount) - parseFloat(transaction.tr_fees)).toLocaleString("pt-br", {minimumFractionDigits: 2, maximumFractionDigits: 2})}</span></Td>
            <Td>
              <div className="d-flex align-items-start justify-content-start">
                <CircleStatus color={circleColorDefiner(transaction.tr_status)}/>
                {translateStatus(transaction.tr_status)}
              </div>
            </Td>
            <Td>{transaction.bu_firstName && transaction.bu_lastName ? `${transaction.bu_firstName} ${transaction.bu_lastName}` : null } </Td>
            <Td>{transaction.bu_taxpayerId ? transaction.bu_taxpayerId : null}</Td>
            {/* <Td>{transaction.dueDate}</Td> */}
            <Td>{date}</Td>
            <Td>{dateUpdate}</Td>
            <Td>{translatePaymentType(transaction.tr_paymentType)}</Td>
            <Td style={{paddingTop: 9}}>{isDetailsButtonShowed(transaction)}</Td>
          </tr>
        )
      });
    }
  }

  const circleColorDefiner = (status: string) => {
    switch (status){
      case "succeeded":
        return colors.green;
      
      case "pending":
        return colors.yellow;
      
      case "failed":
        return colors.redDark;
      
      default:
        return colors.gray;
    }
  }

  const tableFutureContentGenerator = () => {
    return transfersFuture.map((transfer) => (
      <tr key={transfer.id} style={{ height: 67 }}>
        <Td>R$ {(parseInt(transfer.amount) / 100).toLocaleString("pt-br", { maximumFractionDigits: 2, minimumFractionDigits: 2 })}</Td>
        <Td>R$ {(parseInt(transfer.netAmount) / 100).toLocaleString("pt-br", { maximumFractionDigits: 2, minimumFractionDigits: 2 })}</Td>
        <Td>
          <div className="d-flex align-items-start justify-content-start">
            <CircleStatus color={circleColorDefiner("pending")}/>
            {translateStatus(transfer.status)}
          </div>
        </Td>
        <Td>{transfer.payment_method.holder_name}</Td>
        <Td>{moment(transfer.expected_on).format("DD/MM/YYYY")}</Td>
        <Td>{translatePaymentType(transfer.payment_type)} {transfer.payment_method.first4_digits}</Td>
      </tr>
    ));
  }

  const searchForErrorOnSubmit = (errors: any) => {
    if(errors !== {}){
      setErrorOnSubmit(true);
    } else {
      setErrorOnSubmit(false)
    }
  }

  const handleExport = async () => {
    setIsDisabled(true)
    const { data } = await api.get("/transaction/list", {
      params: {
        bid: login.user.branchs.sellerOwnerPayId,
        exportFilter: true
      }
    });
    
    window.open(`${serverPath}/${data}`)
    setIsDisabled(false)
  }

  const handleExportFutureTransactions = async () => {
    try {
      setIsDisabled(true)
      const { data } = await api.get("/branch/transfers/future", {
        params: {
          sellerOwnerPayId: login.user.branchs.sellerOwnerPayId,
          page: pageFuture,
          exportFilter: true
        }
      });
      
      window.open(`${serverPath}/${data}`)
      toastCreate("exportSucess", "success", 2500, "Dados exportados com sucesso")
      setIsDisabled(false)
    } catch (error) {
      
    }
  }

  const generateBranchOptions = () => {
    return owner.branchs.map((branch: any) => {
      return(
        <option key={branch.id} value={branch.id}>{branch.businessName}</option>
      )
    })
  }

  const handleChangeSelectBranch = (e: any) => {
    const selectedBranchId = e.target.value;
    const selectedBranch = owner.branchs.filter((branch: any) => branch.id === selectedBranchId);
    
    setSelectedBranch(selectedBranchId);

    dispatch(changeUser({
      ...login.user,
      branchs: selectedBranch[0],
      branchsId: selectedBranchId
    }));
  }

  const generateSteps = () => {
    let steps = [];
    
    if(login.user.groups.cm1r1 === true){
      steps.push({
        selector: "#futureButton",
        content: () => (
          <div>
            <TitleTour>Novidade</TitleTour>
            <ContentText>Agora você pode visualizar os detalhes dos lançamentos futuros</ContentText>
          </div>
        ),
      })
    }

    if(login.user.groups.cm8 === true){
      steps.push({
        selector: "#Campanhas",
        content: () => (
          <div>
            <TitleTour>Novidade</TitleTour>
            <ContentText>Agora você pode criar e gerenciar campanhas de doação</ContentText>
          </div>
        ),
      });
    }

    return steps;
  }

  const tableFormaterDefiner = () => {
    if(tableNavigation === 0) {
      return(
        <Table
          filter={true}
          page={pageTransactions}
          maximumPage={maximumPageTransactions}
          setPage={setPageTransactions}
          showExportButton={login.user.groups.cm1e} //login.user.groups.cm1e
          handleExport={handleExport}
          isButtonDisabled={isDisabled}
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          filterGraficButton={filterGraficButton}
          setFilterGraficButton={setFilterGraficButton}
          searchAndFilter={true}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          setTypeSearch={setSearchType}
          arrayForSelect={["name", "status"]}
        >
            <THead>
              <tr>
                <Th>Valor Bruto</Th>
                <Th>Taxa</Th>
                <Th>Valor Líquido</Th>
                <ThFilterable>
                  <div>Status</div>
                  <div style={{ marginLeft: 3, lineHeight: 0.7 }}>
                    <img src={upArrow} alt="seta para cima" />
                    <br />
                    <img src={downArrow} alt="seta para baixo" />
                  </div>
                </ThFilterable>
                <Th>Nome</Th>
                <Th>Cpf</Th>
                <Th>Data da venda</Th>
                <Th>Data do pagamento</Th>
                <Th>MÉTODO DE PAGAMENTO</Th>
                <Th></Th>
              </tr>
            </THead>
            {
              isLoading 
              ? <Animation/>
              : <tbody>
                  {tableContentGenerator()}
              </tbody>
            }
          </Table>
      )
    }
    
    if(tableNavigation === 1){
      return(
        <Table
          page={transferPage}
          maximumPage={transferMaxPage}
          setPage={setTransferPage}
          nonFilterable={true}
        >
          <THead>
              <tr>
                <Th>Valor</Th>
                <ThFilterable>
                  <div>Status</div>
                  <div style={{ marginLeft: 3, lineHeight: 0.7 }}>
                    <img src={upArrow} alt="seta para cima" />
                    <br />
                    <img src={downArrow} alt="seta para baixo" />
                  </div>
                </ThFilterable>
                <Th>Nome</Th>
                <Th>Cpf/Cnpj</Th>
                <Th>Data da transferência</Th>
                <Th></Th>
              </tr>
            </THead>
            {
              isLoading 
              ? <Animation/>
              : <tbody>
                  {tableTransferContentGenerator()}
              </tbody>
            }
        </Table>
      )
    }
  }
  
  useEffect(() => {
    const getTrasferDataAtApi = async () => {
      if(selectedBranch.id !== undefined){

      } else {
        const {data} = await api.post(`branch/transfers/details?page=${transferPage}`,{
          sellerOwnerPayId: login.user.branchs.sellerOwnerPayId
        });
        
        setTransferMaxPage(data.pageCount)
        setTransferData(data.branchTransfer);
      }
    }
    
    switch(tableNavigation){
      case 1:
        getTrasferDataAtApi();
        
        return;
      
        default: return;
    }
  }, [tableNavigation ,selectedBranch, transferPage])

  const tableTransferContentGenerator = () => {
    return transferData?.map((transfer) => (
      <tr key={transfer.id} style={{ height: 67 }}>
        <Td><span>R${parseFloat(transfer.amount).toLocaleString("pt-br", {maximumFractionDigits: 2, minimumFractionDigits: 2})}</span></Td>
        <Td>
          <div className="d-flex align-items-start justify-content-start">
            <CircleStatus color={circleColorDefiner(transfer.status)}/>
            {translateStatus(transfer.status)}
          </div>
        </Td>
        <Td>{`${transfer.bank_account.holder_name}`}</Td>
        <Td>{transfer.bank_account.taxpayer_id}</Td>
        <Td>{moment(transfer.transfer_date).add(3, "hours").format("DD/MM/YYYY")}</Td>
        <Td style={{paddingTop: 9}}><DetailsButton onClick={() => handleClickTransferDetail(transfer)}><span style={{height: 8}}>Ver detalhes</span></DetailsButton></Td>
      </tr>
    ));
  }

  const handleClickTransferDetail = (transfer: any) => {
    setSelectedTransferData(transfer);
    openModal("transfers");
  }

  return (
    <div className="d-flex">
      <ToastContainer/>
      <ModalTransfers id="transfers" data={selectedTransferData}/>
      <Tour
        steps={generateSteps()}
        isOpen={isTourOpen}
        onRequestClose={() => setIsTourOpen(false)} 
        accentColor={colors.primary}
        showNumber={false}
        showNavigation
        showNavigationNumber={false}
        showButtons
      />

      {login.user.groups.cm1u ? 
        <Modal title="Realizar Transferência" subtitle="Selecione o valor e a conta para a qual deseja transferir" id="transfer">
          <TransferContainer>
            <TransferBalance>
              <Title>Saldo disponível</Title>
              <div>
                <BalanceCurrecy>R$ </BalanceCurrecy>
                <BalanceValue>{avaliableBalance.toLocaleString("pt-br", {maximumFractionDigits: 2, minimumFractionDigits: 2})}</BalanceValue>
              </div>
            </TransferBalance>
            <FormAndTransferContainerFlex>
              <div className="w-100">
                <Title>Transferência</Title>
                <Formik
                  initialValues={{
                    amount: "",
                    password_transfer: ""
                  }}
                  validationSchema={formValidationWithYup}
                  onSubmit={async (values) => {
                    values.amount = parseFloat(values.amount.replace(",", ".")).toLocaleString("pt-br", {maximumFractionDigits: 2, minimumFractionDigits: 2})
                    const amount = values.amount.split(",");
                    const amountInCents = (parseInt(amount[0]) * 100) + parseInt(amount[1]);

                    if(amountInCents > avaliableBalance){
                      setErrorOnSubmit(true)
                    } else {
                      setErrorOnSubmit(false)
                      
                      try {
                        await api.post("branch/bank/transfers", {
                          "bank_account_id": paymentOptionsData.id,
                          "sellerOwnerPayId": login.user.branchs.sellerOwnerPayId,
                          "amount": amountInCents,
                          "apiOwnerId": login.user.powerUser === true ? "ZOOP" : login.user.branchs.apiOwner.description,
                          "password": values.password_transfer
                        });
                      } catch (error) {
                        
                      }
                    }

                  }}
                >
                    {({errors}) => {
                      return(
                        <Form>
                          <FormInput>
                            <Field 
                              id="amount" 
                              name="amount"
                              min="0"
                              placeholder="Valor a transferir" 
                              className="inputTransferModal"
                              style={{borderColor: `${errors.amount || (errorOnSubmit && !errors.amount) ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                              as={Input}
                            />
                            <Field 
                              id="password_transfer" 
                              name="password_transfer" 
                              placeholder="Confirme sua senha"
                              className="inputTransferModal" 
                              as={Input}
                            />
                            <Button 
                              type="submit" 
                              style={{height: 32}}
                              onClick={() => {
                                searchForErrorOnSubmit(errors);
                              }}
                            >
                              Transferir
                            </Button>
                          </FormInput>
                        </Form>
                      )
                    }}
                </Formik>
              </div>
            </FormAndTransferContainerFlex>
          </TransferContainer>
          <BankAccountAndSelectAnotherContainer className="mb-5">
            <BankAccount>
              <BankAccountContainer>
                  <BankAccountContainerHeader>
                      <div className="d-flex align-items-center">
                          <BankAccountContainerHeaderTitle isPrimary={true}>
                              Conta Primária
                          </BankAccountContainerHeaderTitle>
                      </div>

                      <RadioButtonContainer>
                          <RadioButtonContent isPrimary={true}/>
                      </RadioButtonContainer>
                  </BankAccountContainerHeader>

                  <BankAccountContainerBody>
                      <div className="col-6" style={{padding: 0}}>
                          <DataContainer>
                              <AccountTitle>Banco</AccountTitle>
                              <Info>{paymentOptionsData.bank_name}</Info>
                          </DataContainer>

                          <div className="d-flex">
                              <div className="col-6" style={{padding: 0}}>
                                  <DataContainer>
                                      <AccountTitle>Agência</AccountTitle>
                                      <Info>{paymentOptionsData.routing_number}</Info>
                                  </DataContainer>
                              </div>

                              <div className="col-6" style={{padding: 0}}>
                                  <DataContainer>
                                      <AccountTitle>Dígito</AccountTitle>
                                      <Info>{paymentOptionsData.routing_check_digit}</Info>
                                  </DataContainer>
                              </div>
                          </div>

                          <DataContainer>
                              <AccountTitle>Titular</AccountTitle>
                              <Info>{paymentOptionsData.holder_name}</Info>
                          </DataContainer>
                      </div>
                      <div className="col-6">
                          <DataContainer>
                              <AccountTitle>Tipo de conta</AccountTitle>
                              <Info>{paymentOptionsData.type}</Info>
                          </DataContainer>

                          <DataContainer>
                              <AccountTitle>Conta</AccountTitle>
                              <Info>{paymentOptionsData.account_number}</Info>
                          </DataContainer>

                          <DataContainer>
                              <AccountTitle>CNPJ</AccountTitle>
                              <Info>{paymentOptionsData.taxpayer_id}</Info>
                          </DataContainer>
                      </div>
                  </BankAccountContainerBody>
              </BankAccountContainer>
            </BankAccount>
          </BankAccountAndSelectAnotherContainer>
        </Modal> : null
      }

      {true ? // login.user.groups.cm1r1
        <Modal title="Lançamentos futuros" subtitle="Lançamentos previstos para entrar na sua conta" id="futureTransfer">
          <div className="mb-5">
            <div className="d-flex flex-wrap">
              <CardDetailsFutureValue>
                <Title style={{marginBottom: 20}}>Valor previsto total</Title>
                <BalanceCurrecy>R$</BalanceCurrecy>
                <BalanceValue>{futureBalance.toLocaleString("pt-br", {minimumFractionDigits: 2, maximumFractionDigits: 2})}</BalanceValue>
              </CardDetailsFutureValue>
              <CardDetailsFutureValue>
                <Title style={{marginBottom: 20}}>Valor previsto por página</Title>
                <BalanceCurrecy>R$</BalanceCurrecy>
                <BalanceValue>{totalAmountPerPage.toLocaleString("pt-br", {minimumFractionDigits: 2, maximumFractionDigits: 2})}</BalanceValue>
              </CardDetailsFutureValue>
            </div>
            <Table
              filter={true}
              page={pageFuture}
              maximumPage={maximumPageFuture}
              setPage={setPageFuture}
              showExportButton={login.user.groups.cm1r1}
              nonFilterable
              handleExport={handleExportFutureTransactions}
              isButtonDisabled={isDisabled}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
            >
              <THead>
                <tr>
                  <Th>Valor</Th>
                  <Th>Valor Líquido</Th>
                  <Th>Status</Th>
                  <Th>Nome</Th>
                  <Th>Vencimento</Th>
                  <Th>MÉTODO DE PAGAMENTO</Th>
                </tr>
              </THead>
              {
                isLoading 
                ? <Animation/>
                : <tbody>
                    {tableFutureContentGenerator()}
                </tbody>
              }
            </Table>
          </div>

        </Modal> : null
      }

      <ModalDetails id="details" data={transactionSelected}/>

      <Main>
        { login.user.powerUser === true && (
          <SelectBranchContainer>
            <SelectBranchText>Seleciona um estabelecimento:</SelectBranchText>
            <Select style={{width: "45%", marginBottom: 0}} value={selectedBranch} onChange={(e) => handleChangeSelectBranch(e)}>
              { generateBranchOptions() }
            </Select>
          </SelectBranchContainer>
        )}
        <DashboardHeader/>
        <BalanceContainer>
          {
            login.user.groups.cm1u ?
              <DashboardBalanceBoxContainer>
                <DashboardBalanceBox
                  id="transferButton"
                  modalId="transfer"
                  title="Saldo disponível"
                  value={avaliableBalance}
                  textButton="Transferir"
                  isButtonShowed={login.user.groups.cm1u}
                  icon={bankWhite}
                  ps="*Valor sujeito a mudanças até o final do dia"
                />
              </DashboardBalanceBoxContainer> : null
          }
        
        {
          login.user.groups.cm1r1 ?
            <DashboardBalanceBoxContainer>
              <DashboardBalanceBox
                id="futureButton"
                modalId="futureTransfer"
                title={"Saldo a receber"} // - ${months[moment().month()]}
                value={futureBalance}
                textButton="Visualizar detalhes"
                isButtonShowed={true} //login.user.groups.cm1r1
                ps="*Lançamentos previstos para entrar na sua conta"
              />
            </DashboardBalanceBoxContainer> : null
        }
        
        </BalanceContainer>

        <Graphic 
          sellerOwnerPayId={login.user.branchs !== null ? login.user.branchs.sellerOwnerPayId : null}
          type={typeGraphic}
          setType={setTypeGraphic}
          />
        
        {true ? ( //login.user.groups.am1r4
            <>
              <NavigationContainer className="nav nav-tabs">
                <a 
                  className={`nav-link ${tableNavigation === 0 ? "active" : ""}`}
                  onClick={() => setTableNavigation(0)}
                >
                  <li className="nav-item">
                    <TextContainer>
                      <span>LISTA DE VENDAS</span>
                    </TextContainer>
                  </li>
                </a>

                <a 
                  className={`nav-link ${tableNavigation === 1 ? "active" : ""}`}
                  onClick={() => setTableNavigation(1)}
                >
                  <li className="nav-item">
                    <TextContainer>
                      <span>TRANSFERÊNCIAS</span>
                    </TextContainer>
                  </li>
                </a>
              </NavigationContainer>
              {tableFormaterDefiner()}
            </> ) : null
          }
          <Link to="/doubts/faq">
            <LinkToChatMobile>
                <LinkToChatContainer style={{marginBottom: 30}}>
                  
                    <div className="d-flex">
                      <LinkToChatBallon>
                        <div>
                          <LinkToChatTextRed>Precisa de ajuda ?</LinkToChatTextRed>
                          <LinkToChatTextBlack>Diga-nos o que precisa...</LinkToChatTextBlack>
                        </div>
                      </LinkToChatBallon>
                      <BallonTriangle/>
                    </div>
                    <div>
                      <img src={chatImg} style={{marginLeft: -15}}/>
                    </div>
                  
                </LinkToChatContainer>
            </LinkToChatMobile>
          </Link>
      </Main>
      <SideContainer>
        <DashboardLastTransfers
          transfers={last4Transaction}
        />
        <Link to="/doubts/faq">
          <LinkToChatContainer>
            <div className="d-flex">
              <LinkToChatBallon>
                <div>
                  <LinkToChatTextRed>Precisa de ajuda ?</LinkToChatTextRed>
                  <LinkToChatTextBlack>Diga-nos o que precisa...</LinkToChatTextBlack>
                </div>
              </LinkToChatBallon>
              <BallonTriangle/>
            </div>
            <div>
              <img src={chatImg} style={{marginLeft: -15}}/>
            </div>
          </LinkToChatContainer>
        </Link>
      </SideContainer>
    </div>
  );
}

export default Dashboard;